import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { EReplaceShowStrategy } from "../../../../domain/show-repository";

@Component({
  selector: "evrideo-replace-show-item-is-shorter",
  templateUrl: "./item-is-shorter.component.html",
  styleUrls: ["../common/attention-popup.component.scss"],
})
export class ReplaceShowModalItemIsShorterComponent implements OnInit {
  selectedOption = EReplaceShowStrategy.Default;

  @Input()
  differenceInMS = 0;

  @Input()
  channelFramerate: number;

  @Output()
  strategyChanged = new EventEmitter<EReplaceShowStrategy>();

  constructor() {}

  ngOnInit() {
    this.strategyChanged.emit(EReplaceShowStrategy.Default);
  }
}
